<div
  class="container-fluid d-flex flex-row justify-content-center mb-0 mt-md-1 pt-0 pt-md-3 pt-xl-0 pb-0 shadow-lg col-xs-12 col-lg-8"
>
  <div class="jumbotron-fluid col-12 col-sm-8 col-md-7 col-xl-6 mb-0 pb-0">
    <div class="container mt-3 mb-2 mx-0 shadow-lg">
      <div class="row">
        <div class="col-12">
          <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
            Loan Amortization Cycle </h4>
        </div>
      </div>
    </div>
    <div class="card-body mt-1 pt-3 pb-4 mb-0 mx-auto shadow-lg">
      <form
        [formGroup]="userForm"
        (ngSubmit)="setAmortizationCycle()"
      >
        <div class="d-flex mt-0 mb-2 py-0 mx-auto">
          <div
            *ngIf="checkedClient"
            class="row"
          >
            <div class="col-12 text-left text-info h6"><strong>Selected Client Details</strong></div>
            <div class="col-6">ID: <strong>{{checkedClient.customerId}} </strong></div>
            <div class="col-6">Name: <strong>{{checkedClient.customerName}} </strong></div>
            <div class="col-6">Phone: <strong>{{checkedClient.customerPhone1}}</strong></div>
            <div class="col-6">Secret Pin: <strong>{{checkedClient.customerSecretPin}}</strong></div>
          </div>
        </div>
        <div class="d-flex mt-0 mb-2 py-0 mx-auto">
          <button
            (click)="selectFromData(dataModal, 100)"
            class="btn btn-info col-5 mx-auto"
            type="button"
          >
            Select Client
          </button>
          <button
            (click)="getStatement(template)"
            [disabled]="!checkedClient?.customerId"
            class="btn btn-info col-5 mx-auto"
            type="button"
          >
            Client's statement
          </button>
        </div>
        <div class="form-group text-primary">
          <label
            for="cycle"
            [ngClass]="fval.cycle.valid ? 'text-info' : ''"
          >Amortization Cycle<i
              *ngIf="fval.cycle.valid"
              class="material-icons"
            >check_circle</i></label>
          <div class="input-group mb-0">
            <select
              formControlName="cycle"
              class="form-control"
              [ngClass]="{
            'is-invalid':
              (fval.cycle.touched || fval.cycle.dirty) &&
              fval.cycle.errors
          }"
              autocomplete="off"
            >
              <option
                class="place-holder-select"
                disabled
                hidden
                selected
                value=""
              >
                Select Amortization Cycle
              </option>
              <option
                *ngFor="let item of cycles"
                [value]="item.code"
              >
                {{ item.name }}
              </option>
            </select>
          </div>
          <div
            class="text-danger col"
            *ngIf="
            (fval.cycle.touched || fval.cycle.dirty) &&
            fval.cycle.errors?.required
          "
          >
            The Amortization cycle is required!
          </div>
        </div>

        <div class="d-flex mt-3 mb-1 pt-1 pb-2 mx-auto">
          <ngx-alerts></ngx-alerts>
          <button
            type="submit"
            class="btn btn-info col-5 mx-auto"
            [disabled]="!userForm.valid || !checkedClient?.customerId || loading"
          >
            Save
          </button>

          <button
            type="button"
            class="btn btn-info col-5 mx-auto"
            (click)="revert()"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
<ng-template #template>
  <app-statement-modal
    (close)="getClose($event)"
    [data]="statement"
    [customerName]="checkedClient.customerName"
  >
  </app-statement-modal>
</ng-template>
<ng-template #dataModal>
  <app-data-modal
    (close)="getClose($event)"
    (result)="getResult($event)"
    [dataKind]="selectionKind"
    [data]="selectionData"
    [title]="modalTitle"
  ></app-data-modal>
</ng-template>
